<template>
  <v-card>
    <v-card-text>
      <v-switch
          v-model="filterReady"
          label="Filter status bewerkt"
          @change="doSwitch()"
          color="primary"
      ></v-switch>
      <address-list-pageable
          :addresses="addresses"
          show-postcode
          show-date
          show-time
          v-if="addressViewReady"
      ></address-list-pageable>
      <v-pagination v-model="pagination.page" :length="pagination.pages" @input="load()"></v-pagination>
    </v-card-text>
  </v-card>
</template>
<script>
import {adminService as service} from "@/services/admin";
import AddressListPageable from "@/components/AddressListPageable";

export default {
  components: {
    AddressListPageable
  },
  data: () => ({
    sending: false,
    filterReady: true,
    pagination: {
      page: 1,
      pages: 0
    },
    addressViewReady: false,

    addresses: []
  }),
  methods: {
    doSwitch() {
      this.pagination = {
        page: 1,
        pages: 1
      };
      this.load();
    },
    load() {
      this.sending = true;

      var query = {
        filterReady: this.filterReady,
        pageNumber: this.pagination.page - 1
      };

      service
          .getAddresses(query)
          .then(result => {
            this.addresses = result.data.content;
            this.pagination = {
              page: result.data.pageable.pageNumber + 1,
              pages: result.data.totalPages
            };
            // this.page = result.data.pageable;
            // this.totalElements = result.data.totalElements;
            // this.totalPages = result.data.totalPages;
            // this.first = result.data.first;
            // this.last = result.data.last;
            this.addressViewReady = true;
            this.sending = false;
          })
          // eslint-disable-next-line
          .catch(() => console.log("Error!"));
    }
  },
  created() {
    this.load();
  }
};
</script>
